module.exports = __webpack_public_path__ + "static/media/margate-14.74b896cc.jpg";